import React, { useState } from "react";

import { CloseGreyIcon } from "../../../assets/icons";
import { Switch } from "@mui/material";
import { useNotification } from "../../toster-notification/NotificationContext";
import { categoriesService } from "../../../services/categoriesService";
import { useParams } from "react-router-dom";
import Loader from "../../shared/Loader";

interface AddCategoryViewProps {
    onClose: () => void;
}

const AddCategoryView: React.FC<AddCategoryViewProps> = ({ onClose }) => {

    const [categoryName, setCategoryName] = useState<string>("");
    const [categoryNameError, setCategoryNameError] = useState<string>("");
    const [categorySlug, setCategorySlug] = useState<string>("");
    const [categorySlugError, setCategorySlugError] = useState<string>("");
    const [isActive, setIsActive] = useState<boolean>(true);

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();

    const { localId } = useParams<{ localId: string }>();


    const handleCreateCategory = async () => {

        setCategoryNameError("");
        setCategorySlugError("");

        let isValid = true;

        if (categoryName.trim() === "") {
            setCategoryNameError("Naziv kategorije je obavezan.");
            isValid = false;
        }

        if (categorySlug.trim() === "") {
            setCategorySlugError("Slug kategorije je obavezan.");
            isValid = false;
        }

        if (!isValid) {
            return;
        }

        setLoading(true);

        try {
            const response = await categoriesService.createCategory({
                localId: localId!,
                name: categoryName,
                slug: categorySlug,
                isActive: isActive,
            });

            if (response.success && response.message) {
                notify("success", "Kategorija je uspešno kreirana.");
                onClose();
            } else {
                notify("error", "Došlo je do greške prilikom kreiranja kategorije.");
            }
        } catch (error: any) {
            notify("error", "Došlo je do greške prilikom kreiranja kategorije.");
        } finally {
            setLoading(false);
        }
    };

    const setSlugName = (name: string) => {
        return name
            .toLowerCase()
            .replace(/š/g, 's')
            .replace(/č/g, 'c')
            .replace(/ć/g, 'c')
            .replace(/ž/g, 'z')
            .replace(/đ/g, 'dj')
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9\-]/g, '');
    }

    if (loading) {
        return <Loader />;
    }

    return (
        <section className="modal-section category">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">Nova kategorija</div>
                                <div className="description-text">Unesite podatke o kategoriji</div>
                            </div>
                            <div className="modal-button-div" onClick={onClose}>
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form className="modal-form">
                                <div className="modal-form-div">
                                    <label className="modal-form-label">Naziv*</label>
                                    <input className="form-input grey w-input" placeholder="Unesite naziv kategorije" type="text"
                                        value={categoryName}
                                        onChange={(e) => {
                                            setCategoryName(e.target.value);
                                            setCategorySlug(setSlugName(e.target.value));
                                        }}
                                    />
                                    <div className="error-text">{categoryNameError}</div>
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">Slug</label>
                                    <input className="form-input grey w-input" placeholder="Unesite slug kategorije" type="text"
                                        value={categorySlug}
                                        onChange={(e) => setCategorySlug(e.target.value)}
                                    />
                                    <div className="error-text">{categorySlugError}</div>
                                </div>
                                <div className="modal-form-div f-horizontal">
                                    <label className="modal-form-label">Akivna kategorija*</label>
                                    <Switch
                                        checked={isActive}
                                        onChange={(e) => setIsActive(e.target.checked)}
                                    />
                                </div>
                            </form>

                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={onClose}>
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium" onClick={() => handleCreateCategory()}>
                                <div>Kreiraj</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AddCategoryView;
